import React, { useEffect, useState } from "react";
import { Button, Typography } from "@material-ui/core";
import Modal from "../../../components/Modal";
import { useTranslation } from "../../../langs/useTranslation";
import ManagerList from ".";
import styles from "./index.module.less";

function Index({
  open,
  list,
  getDefaultColumns,
  onConfirm,
  onChange,
  onClose
}) {
  const { t } = useTranslation();
  const [innerList, setInnerList] = useState([]);

  const handleConfirm = () => {
    return onConfirm?.(innerList);
  };

  const handleChange = list => {


    console.log(list);
    setInnerList(list);
    onChange?.(list);
  };

  const handleReset = () => {
    setInnerList(getDefaultColumns());
  };

  useEffect(() => {
    if (open) {
      setInnerList(list);
    }
  }, [list, open]);

  return (
    <>
      <Modal
        title={t({ defaultMessage: "自定义显示" })}
        width={500}
        open={open}
        onClose={onClose}
        onConfirm={handleConfirm}
      >
        <Typography
          variant="body2"
          color="textSecondary"
          className={styles.desc}
        >
          {t({ defaultMessage: "勾选需要显示的栏位，可拖动进行排序" })}
        </Typography>
        <ManagerList value={innerList} onChange={handleChange} />
        {/*<DemoList value={innerList}/>*/}
        <div className={styles.resetBtn}>
          <Button color="primary" onClick={handleReset}>
            {t({ defaultMessage: "恢复默认" })}
          </Button>
        </div>
      </Modal>
    </>
  );
}

export default Index;
